import { fetchOnlinePrograms } from '../../new-infra-fetchers/online-programs/fetch-online-programs';
import { updateOnlineProgramsCoverImage } from './update-online-programs-cover-image-alt';
import { updateOnlineProgramsQuizzesImages } from './update-online-programs-forms-images';
import { updateOnlineProgramsInstructorsImages } from './update-online-programs-instructors-images';
import { updateOnlineProgramsStepsImages } from './update-online-programs-steps-images';
export const updateOnlinePrograms = async (httpClient, errorHandler, altTextData) => {
  const entityIdsList = [...new Set(altTextData.map(item => item.entityId).filter(entityId => entityId !== undefined))];
  const onlineProgramsData = await fetchOnlinePrograms(httpClient, errorHandler, entityIdsList);
  if (!onlineProgramsData) {
    return {
      success: false
    };
  }
  const coverImageAlt = [];
  const instructorsAlt = [];
  const stepsAlt = [];
  const quizzesAlt = [];
  const {
    onlineProgramsInstructorsData,
    onlineProgramsCoverImageData,
    onlineProgramsStepsData,
    onlineProgramsQuizStepsData
  } = onlineProgramsData;
  altTextData.forEach(altData => {
    if (onlineProgramsInstructorsData.imagesInstructorsMap[altData.id] !== undefined) {
      instructorsAlt.push(altData);
    } else if (onlineProgramsCoverImageData.imagesProgramsMap[altData.id] !== undefined) {
      coverImageAlt.push(altData);
    } else if (onlineProgramsStepsData.imagesToStepMap[altData.id] !== undefined) {
      stepsAlt.push(altData);
    } else {
      quizzesAlt.push(altData);
    }
  });
  const results = await Promise.allSettled([updateOnlineProgramsInstructorsImages(httpClient, errorHandler, instructorsAlt, onlineProgramsInstructorsData), updateOnlineProgramsCoverImage(httpClient, errorHandler, coverImageAlt, onlineProgramsCoverImageData), updateOnlineProgramsStepsImages(httpClient, errorHandler, stepsAlt, onlineProgramsStepsData), updateOnlineProgramsQuizzesImages(httpClient, errorHandler, quizzesAlt, onlineProgramsQuizStepsData)]);
  return results.every(result => result.status === 'fulfilled') ? {
    failedElements: results.flatMap(result => {
      var _result$value;
      return ((_result$value = result.value) == null ? void 0 : _result$value.failedElements) ?? [];
    }),
    success: true
  } : {
    success: false
  };
};
//# sourceMappingURL=update-online-programs.js.map